import {reverse} from '@utils/helper';

const CAMPAIGN_STATUS = {
    AWAIT_DELIVERY: {
        id: 0,
        text: '待投',
        color: 'warning',
    },
    DELIVERY: {
        id: 1,
        text: '在投',
        color: 'success',
    },
    PAUSE: {
        id: 2,
        text: '暂停',
        color: 'info',
    },
    OVER: {
        id: 3,
        text: '结束',
        color: 'info',
    },
    AWAIT_AUDIT: {
        id: 4,
        text: '待审',
        color: 'warning',
        non: true,
    },
    REJECT: {
        id: 5,
        text: '驳回',
        color: 'danger',
        non: true,
    },
};
const REVERSE_CAMPAIGN_STATUS = reverse(CAMPAIGN_STATUS);

export { CAMPAIGN_STATUS, REVERSE_CAMPAIGN_STATUS };
